import { gsap, Elastic } from "gsap/all";
import CounterNums from "./CounterNums";
import { SplitText } from "../plugins/gsap/SplitText";
import HoverSVGAnimation from "./animation/HoverSVGAnimation";
gsap.registerPlugin(SplitText);

if (!("IntersectionObserver" in window)) {
    (function(undefined) {function ArrayCreate(r){if(1/r==-Infinity&&(r=0),r>Math.pow(2,32)-1)throw new RangeError("Invalid array length");var n=[];return n.length=r,n}function Call(t,l){var n=arguments.length>2?arguments[2]:[];if(!1===IsCallable(t))throw new TypeError(Object.prototype.toString.call(t)+"is not a function.");return t.apply(l,n)}function CreateDataProperty(e,r,t){var a={value:t,writable:!0,enumerable:!0,configurable:!0};try{return Object.defineProperty(e,r,a),!0}catch(n){return!1}}function CreateDataPropertyOrThrow(t,r,o){var e=CreateDataProperty(t,r,o);if(!e)throw new TypeError("Cannot assign value `"+Object.prototype.toString.call(o)+"` to property `"+Object.prototype.toString.call(r)+"` on object `"+Object.prototype.toString.call(t)+"`");return e}function CreateMethodProperty(e,r,t){var a={value:t,writable:!0,enumerable:!1,configurable:!0};Object.defineProperty(e,r,a)}function Get(n,t){return n[t]}function HasProperty(n,r){return r in n}function IsArray(r){return"[object Array]"===Object.prototype.toString.call(r)}function IsCallable(n){return"function"==typeof n}function ToBoolean(o){return Boolean(o)}function ToInteger(n){var i=Number(n);return isNaN(i)?0:1/i===Infinity||1/i==-Infinity||i===Infinity||i===-Infinity?i:(i<0?-1:1)*Math.floor(Math.abs(i))}function ToLength(n){var t=ToInteger(n);return t<=0?0:Math.min(t,Math.pow(2,53)-1)}function ToObject(e){if(null===e||e===undefined)throw TypeError();return Object(e)}function GetV(t,e){return ToObject(t)[e]}function GetMethod(e,n){var r=GetV(e,n);if(null===r||r===undefined)return undefined;if(!1===IsCallable(r))throw new TypeError("Method not callable: "+n);return r}function Type(e){switch(typeof e){case"undefined":return"undefined";case"boolean":return"boolean";case"number":return"number";case"string":return"string";case"symbol":return"symbol";default:return null===e?"null":"Symbol"in this&&e instanceof this.Symbol?"symbol":"object"}}function GetPrototypeFromConstructor(t,o){var r=Get(t,"prototype");return"object"!==Type(r)&&(r=o),r}function OrdinaryCreateFromConstructor(r,e){var t=arguments[2]||{},o=GetPrototypeFromConstructor(r,e),a=Object.create(o);for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&Object.defineProperty(a,n,{configurable:!0,enumerable:!1,writable:!0,value:t[n]});return a}function IsConstructor(t){return"object"===Type(t)&&("function"==typeof t&&!!t.prototype)}function Construct(r){var t=arguments.length>2?arguments[2]:r,o=arguments.length>1?arguments[1]:[];if(!IsConstructor(r))throw new TypeError("F must be a constructor.");if(!IsConstructor(t))throw new TypeError("newTarget must be a constructor.");if(t===r)return new(Function.prototype.bind.apply(r,[null].concat(o)));var n=OrdinaryCreateFromConstructor(t,Object.prototype);return Call(r,n,o)}function ArraySpeciesCreate(r,e){if(1/e==-Infinity&&(e=0),!1===IsArray(r))return ArrayCreate(e);var t=Get(r,"constructor");if("object"===Type(t)&&null===(t="Symbol"in this&&"species"in this.Symbol?Get(t,this.Symbol.species):undefined)&&(t=undefined),t===undefined)return ArrayCreate(e);if(!IsConstructor(t))throw new TypeError("C must be a constructor");return Construct(t,[e])}function OrdinaryToPrimitive(r,t){if("string"===t)var e=["toString","valueOf"];else e=["valueOf","toString"];for(var i=0;i<e.length;++i){var n=e[i],a=Get(r,n);if(IsCallable(a)){var o=Call(a,r);if("object"!==Type(o))return o}}throw new TypeError("Cannot convert to primitive.")}function ToPrimitive(e){var t=arguments.length>1?arguments[1]:undefined;if("object"===Type(e)){if(arguments.length<2)var i="default";else t===String?i="string":t===Number&&(i="number");var r="function"==typeof this.Symbol&&"symbol"==typeof this.Symbol.toPrimitive?GetMethod(e,this.Symbol.toPrimitive):undefined;if(r!==undefined){var n=Call(r,e,[i]);if("object"!==Type(n))return n;throw new TypeError("Cannot convert exotic object to primitive.")}return"default"===i&&(i="number"),OrdinaryToPrimitive(e,i)}return e}function ToString(t){switch(Type(t)){case"symbol":throw new TypeError("Cannot convert a Symbol value to a string");case"object":return ToString(ToPrimitive(t,"string"));default:return String(t)}}!function(){function e(e,t){for(var n=-1,o=e.length;++n<o;)if(n in e&&e[n]===t)return n;return-1}function t(e,t){if(!e)throw new Error("Not enough arguments");var n;if("createEvent"in document){n=document.createEvent("Event");var o=!(!t||t.bubbles===undefined)&&t.bubbles,i=!(!t||t.cancelable===undefined)&&t.cancelable;return n.initEvent(e,o,i),n}return n=document.createEventObject(),n.type=e,n.bubbles=!(!t||t.bubbles===undefined)&&t.bubbles,n.cancelable=!(!t||t.cancelable===undefined)&&t.cancelable,n}var n={click:1,dblclick:1,keyup:1,keypress:1,keydown:1,mousedown:1,mouseup:1,mousemove:1,mouseover:1,mouseenter:1,mouseleave:1,mouseout:1,storage:1,storagecommit:1,textinput:1};if("undefined"!=typeof document&&"undefined"!=typeof window){var o=window.Event&&window.Event.prototype||null;t.NONE=0,t.CAPTURING_PHASE=1,t.AT_TARGET=2,t.BUBBLING_PHASE=3,window.Event=Window.prototype.Event=t,o&&Object.defineProperty(window.Event,"prototype",{configurable:!1,enumerable:!1,writable:!0,value:o}),"createEvent"in document||(window.addEventListener=Window.prototype.addEventListener=Document.prototype.addEventListener=Element.prototype.addEventListener=function i(){var t=this,o=arguments[0],i=arguments[1];if(t===window&&o in n)throw new Error("In IE8 the event: "+o+" is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.");t._events||(t._events={}),t._events[o]||(t._events[o]=function(n){var o,i=t._events[n.type].list,r=i.slice(),c=-1,a=r.length;for(n.preventDefault=function l(){!1!==n.cancelable&&(n.returnValue=!1)},n.stopPropagation=function s(){n.cancelBubble=!0},n.stopImmediatePropagation=function u(){n.cancelBubble=!0,n.cancelImmediate=!0},n.currentTarget=t,n.relatedTarget=n.fromElement||null,n.target=n.target||n.srcElement||t,n.timeStamp=(new Date).getTime(),n.clientX&&(n.pageX=n.clientX+document.documentElement.scrollLeft,n.pageY=n.clientY+document.documentElement.scrollTop);++c<a&&!n.cancelImmediate;)c in r&&(o=r[c],-1!==e(i,o)&&"function"==typeof o&&o.call(t,n))},t._events[o].list=[],t.attachEvent&&t.attachEvent("on"+o,t._events[o])),t._events[o].list.push(i)},window.removeEventListener=Window.prototype.removeEventListener=Document.prototype.removeEventListener=Element.prototype.removeEventListener=function r(){var t,n=this,o=arguments[0],i=arguments[1];n._events&&n._events[o]&&n._events[o].list&&-1!==(t=e(n._events[o].list,i))&&(n._events[o].list.splice(t,1),n._events[o].list.length||(n.detachEvent&&n.detachEvent("on"+o,n._events[o]),delete n._events[o]))},window.dispatchEvent=Window.prototype.dispatchEvent=Document.prototype.dispatchEvent=Element.prototype.dispatchEvent=function c(e){if(!arguments.length)throw new Error("Not enough arguments");if(!e||"string"!=typeof e.type)throw new Error("DOM Events Exception 0");var t=this,n=e.type;try{if(!e.bubbles){e.cancelBubble=!0;var o=function(e){e.cancelBubble=!0,(t||window).detachEvent("on"+n,o)};this.attachEvent("on"+n,o)}this.fireEvent("on"+n,e)}catch(i){e.target=t;do{e.currentTarget=t,"_events"in t&&"function"==typeof t._events[n]&&t._events[n].call(t,e),"function"==typeof t["on"+n]&&t["on"+n].call(t,e),t=9===t.nodeType?t.parentWindow:t.parentNode}while(t&&!e.cancelBubble)}return!0},document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&document.dispatchEvent(new t("DOMContentLoaded",{bubbles:!0}))}))}}();!function(t,e){"use strict";function n(t){this.time=t.time,this.target=t.target,this.rootBounds=t.rootBounds,this.boundingClientRect=t.boundingClientRect,this.intersectionRect=t.intersectionRect||a();try{this.isIntersecting=!!t.intersectionRect}catch(r){}var e=this.boundingClientRect,n=e.width*e.height,o=this.intersectionRect,i=o.width*o.height;this.intersectionRatio=n?Number((i/n).toFixed(4)):this.isIntersecting?1:0}function o(t,e){var n=e||{};if("function"!=typeof t)throw new Error("callback must be a function");if(n.root&&1!=n.root.nodeType)throw new Error("root must be an Element");this._checkForIntersections=r(this._checkForIntersections.bind(this),this.THROTTLE_TIMEOUT),this._callback=t,this._observationTargets=[],this._queuedEntries=[],this._rootMarginValues=this._parseRootMargin(n.rootMargin),this.thresholds=this._initThresholds(n.threshold),this.root=n.root||null,this.rootMargin=this._rootMarginValues.map(function(t){return t.value+t.unit}).join(" ")}function i(){return t.performance&&performance.now&&performance.now()}function r(t,e){var n=null;return function(){n||(n=setTimeout(function(){t(),n=null},e))}}function s(t,e,n,o){"function"==typeof t.addEventListener?t.addEventListener(e,n,o||!1):"function"==typeof t.attachEvent&&t.attachEvent("on"+e,n)}function h(t,e,n,o){"function"==typeof t.removeEventListener?t.removeEventListener(e,n,o||!1):"function"==typeof t.detatchEvent&&t.detatchEvent("on"+e,n)}function c(t,e){var n=Math.max(t.top,e.top),o=Math.min(t.bottom,e.bottom),i=Math.max(t.left,e.left),r=Math.min(t.right,e.right),s=r-i,h=o-n;return s>=0&&h>=0&&{top:n,bottom:o,left:i,right:r,width:s,height:h}}function u(t){var e;try{e=t.getBoundingClientRect()}catch(n){}return e?(e.width&&e.height||(e={top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.right-e.left,height:e.bottom-e.top}),e):a()}function a(){return{top:0,bottom:0,left:0,right:0,width:0,height:0}}function l(t,e){for(var n=e;n;){if(n==t)return!0;n=p(n)}return!1}function p(t){var e=t.parentNode;return e&&11==e.nodeType&&e.host?e.host:e&&e.assignedSlot?e.assignedSlot.parentNode:e}var f=[];o.prototype.THROTTLE_TIMEOUT=100,o.prototype.POLL_INTERVAL=null,o.prototype.USE_MUTATION_OBSERVER=!0,o.prototype.observe=function(t){if(!this._observationTargets.some(function(e){return e.element==t})){if(!t||1!=t.nodeType)throw new Error("target must be an Element");this._registerInstance(),this._observationTargets.push({element:t,entry:null}),this._monitorIntersections(),this._checkForIntersections()}},o.prototype.unobserve=function(t){this._observationTargets=this._observationTargets.filter(function(e){return e.element!=t}),this._observationTargets.length||(this._unmonitorIntersections(),this._unregisterInstance())},o.prototype.disconnect=function(){this._observationTargets=[],this._unmonitorIntersections(),this._unregisterInstance()},o.prototype.takeRecords=function(){var t=this._queuedEntries.slice();return this._queuedEntries=[],t},o.prototype._initThresholds=function(t){var e=t||[0];return Array.isArray(e)||(e=[e]),e.sort().filter(function(t,e,n){if("number"!=typeof t||isNaN(t)||t<0||t>1)throw new Error("threshold must be a number between 0 and 1 inclusively");return t!==n[e-1]})},o.prototype._parseRootMargin=function(t){var e=t||"0px",n=e.split(/\s+/).map(function(t){var e=/^(-?\d*\.?\d+)(px|%)$/.exec(t);if(!e)throw new Error("rootMargin must be specified in pixels or percent");return{value:parseFloat(e[1]),unit:e[2]}});return n[1]=n[1]||n[0],n[2]=n[2]||n[0],n[3]=n[3]||n[1],n},o.prototype._monitorIntersections=function(){this._monitoringIntersections||(this._monitoringIntersections=!0,this.POLL_INTERVAL?this._monitoringInterval=setInterval(this._checkForIntersections,this.POLL_INTERVAL):(s(t,"resize",this._checkForIntersections,!0),s(e,"scroll",this._checkForIntersections,!0),this.USE_MUTATION_OBSERVER&&"MutationObserver"in t&&(this._domObserver=new MutationObserver(this._checkForIntersections),this._domObserver.observe(e,{attributes:!0,childList:!0,characterData:!0,subtree:!0}))))},o.prototype._unmonitorIntersections=function(){this._monitoringIntersections&&(this._monitoringIntersections=!1,clearInterval(this._monitoringInterval),this._monitoringInterval=null,h(t,"resize",this._checkForIntersections,!0),h(e,"scroll",this._checkForIntersections,!0),this._domObserver&&(this._domObserver.disconnect(),this._domObserver=null))},o.prototype._checkForIntersections=function(){var t=this._rootIsInDom(),e=t?this._getRootRect():a();this._observationTargets.forEach(function(o){var r=o.element,s=u(r),h=this._rootContainsTarget(r),c=o.entry,a=t&&h&&this._computeTargetAndRootIntersection(r,e),l=o.entry=new n({time:i(),target:r,boundingClientRect:s,rootBounds:e,intersectionRect:a});c?t&&h?this._hasCrossedThreshold(c,l)&&this._queuedEntries.push(l):c&&c.isIntersecting&&this._queuedEntries.push(l):this._queuedEntries.push(l)},this),this._queuedEntries.length&&this._callback(this.takeRecords(),this)},o.prototype._computeTargetAndRootIntersection=function(n,o){if("none"!=t.getComputedStyle(n).display){for(var i=u(n),r=i,s=p(n),h=!1;!h;){var a=null,l=1==s.nodeType?t.getComputedStyle(s):{};if("none"==l.display)return;if(s==this.root||s==e?(h=!0,a=o):s!=e.body&&s!=e.documentElement&&"visible"!=l.overflow&&(a=u(s)),a&&!(r=c(a,r)))break;s=p(s)}return r}},o.prototype._getRootRect=function(){var t;if(this.root)t=u(this.root);else{var n=e.documentElement,o=e.body;t={top:0,left:0,right:n.clientWidth||o.clientWidth,width:n.clientWidth||o.clientWidth,bottom:n.clientHeight||o.clientHeight,height:n.clientHeight||o.clientHeight}}return this._expandRectByRootMargin(t)},o.prototype._expandRectByRootMargin=function(t){var e=this._rootMarginValues.map(function(e,n){return"px"==e.unit?e.value:e.value*(n%2?t.width:t.height)/100}),n={top:t.top-e[0],right:t.right+e[1],bottom:t.bottom+e[2],left:t.left-e[3]};return n.width=n.right-n.left,n.height=n.bottom-n.top,n},o.prototype._hasCrossedThreshold=function(t,e){var n=t&&t.isIntersecting?t.intersectionRatio||0:-1,o=e.isIntersecting?e.intersectionRatio||0:-1;if(n!==o)for(var i=0;i<this.thresholds.length;i++){var r=this.thresholds[i];if(r==n||r==o||r<n!=r<o)return!0}},o.prototype._rootIsInDom=function(){return!this.root||l(e,this.root)},o.prototype._rootContainsTarget=function(t){return l(this.root||e,t)},o.prototype._registerInstance=function(){f.indexOf(this)<0&&f.push(this)},o.prototype._unregisterInstance=function(){var t=f.indexOf(this);-1!=t&&f.splice(t,1)},t.IntersectionObserver=o,t.IntersectionObserverEntry=n}(window,document);}).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});
}

class AnimatedAppearingScroll {
    constructor(el) {
        this.bindMethods();
        this.el = el || document.body;
        this.cache = null;
        this.options = null;
        this.observer = null;
        this.init()
    }

    bindMethods() {
        ['handler']
            .forEach((fn) => this[fn] = this[fn].bind(this))
    }

    initItems() {
        this.itemsBlock = Array.from(this.el.querySelectorAll('[data-appear-block], [data-appear-stagger], [data-svg-animation], [data-appear-group], [data-appear-illustration], [data-appear-yt-play], [data-counter-num], [data-appear-corner], [data-appear-typein]'));
    }

    hoverSVGAnimation(el) {
        // find parent with selector [data-svg-hover-animation-root]
        const parent = el.closest('[data-svg-hover-animation-root]')

        if(!parent) return;

        new HoverSVGAnimation(parent);
    }

    inlineSVG () {
        this.inlinedSVGInBatch()
            .then(() => {
                this.elementsInline.forEach((el) => {
                    if(el.dataset.appearIllustration === 'draw') {
                        this.drawSVG(el);
                    }
                    this.hoverSVGAnimation(el);
                })
            })

        // Array.from(this.el.querySelectorAll('[data-appear-illustration]')).forEach((el) => {
        //     var img = el.querySelector('img');
        //     if (typeof img !== 'undefined') {
        //         const src = img.src;
        //
        //         var request = new XMLHttpRequest();
        //         request.open('GET', img.src, true);
        //         request.onreadystatechange = function () {
        //             if (this.readyState == 4 && this.status == 200) {
        //                 var parser = new DOMParser(),
        //                     result = parser.parseFromString(this.responseText, 'text/xml'),
        //                     inlinedSVG = result.getElementsByTagName('svg')[0];
        //
        //                 el.innerHTML = "";
        //                 el.append(inlinedSVG);
        //                 if(el.dataset.appearIllustration === 'draw') {
        //                     setTimeout(() => {
        //                         these.drawSVG(el);
        //                     }, 300);
        //                 }
        //             }
        //         }
        //         request.send(null);
        //     }
        // })
    }

    async fetchSVG (url) {
        try {
            const response = await fetch(url);

            if (response.status !== 200) {
                console.warn(`Failed to fetch SVG from ${url}: ${response.statusText}`);
                return null;
            }

            let text = await response.text();

            // Check if the first line is an HTML doctype declaration
            if (text.startsWith("<!DOCTYPE html>")) {
                console.warn(
                    `The content fetched from ${url} appears to be an HTML document, not an SVG.`
                );
                return null;
            }

            text = text.replace(/<\?xml.*?\?>/, "").trim();

            // Parse SVG and add viewBox if missing
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "image/svg+xml");
            const svgElement = doc.querySelector("svg");

            if (
                !svgElement.getAttribute("viewBox") &&
                svgElement.getAttribute("width") &&
                svgElement.getAttribute("height")
            ) {
                const width = svgElement.getAttribute("width");
                const height = svgElement.getAttribute("height");
                svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
            }

            const serializer = new XMLSerializer();
            return serializer.serializeToString(svgElement);
        } catch (error) {
            console.error(`Error fetching SVG from ${url}: ${error}`);
            return null;
        }
    }

    async inlinedSVGInBatch () {
        this.elementsInline = Array.from(document.querySelectorAll('[data-appear-illustration]'));

        const fetchPromises = this.elementsInline.map((el) => {
            const img = el.querySelector('img');
            if(!img) return;
            const src = img.src;
            // const src = el.dataset.illustrationUrl;
            return this.fetchSVG(src).then((svgText) => {
                if(svgText != null) {
                    el.innerHTML = svgText;
                }
            })
        })

        await Promise.all(fetchPromises);
    }

    init() {
        this.initItems();
        this.getCache()
        this.inlineSVG()
        this.createObserver()
        this.run()
    }

    run() {
        this.cache.forEach(elem => {
            this.observer.observe(elem.el)
        })
    }

    createObserver() {
        this.options = {
            root: null,
            rootMargin: '0px 0px -15% 0px',
            threshold: [0, 0]
        }
        this.observer = new IntersectionObserver(this.handler, this.options)
    }

    drawSVG(el) {
        const paths = [];
        Array.from(el.querySelectorAll('path')).forEach((item) => { paths.push(item)});
        const timeline = gsap.timeline({ paused: true });
        const speed = parseFloat(el.dataset.appearIllustrationSpeed) || 3;

        paths.forEach((item) => {
            const lineLength = item.getTotalLength();
            const delay = item.dataset.pathDraw || 10;
            item.dataset.linelen = lineLength;
            gsap.set(item, {
                attr: {
                    'stroke-dasharray': `${lineLength}  ${lineLength}`,
                    'stroke-dashoffset': lineLength,
                },
            });
            timeline
                .to(item, {duration: speed, attr: {
                        'stroke-dashoffset': 0,
                    }
                }, (delay / 100))
        });
        el.timeline = timeline;

        if(el.mustplay) {
            setTimeout(() => {
                el.timeline.play();
                gsap.to(el, {duration: 0.3, opacity: 1});
            }, 300)
        }

        // gsap.set(el, {opacity: 1});
        // timeline.play();
    }

    typeIn(el) {
        const text = el;
        const timeline = gsap.timeline({ paused: true });

        const split = new SplitText(text, {type: "words,chars", wordsClass: "typein-word", charsClass: "typein-char"});
        const chars = split.chars;


        timeline.from(chars, {
            autoAlpha: 0,
            duration: 1,
            stagger: 0.06,
            ease: "expo.out",
        })

        el.timeline = timeline;

        if(el.mustplay) {
            setTimeout(() => {
                el.timeline.play();
                gsap.to(el, {duration: 0.3, opacity: 1});
            }, 300)
        }
    }

    getCache() {
        this.cache = []
        this.svgAnimations = []
        this.itemsBlock.forEach((el, index) => {
            this.cache.push({
                el: el,
                isIntersected: false,
                elems: null,
                split: null
            })

            if(typeof el.dataset.appearStagger !== 'undefined') {
                const delay = (parseFloat(el.dataset.animationDelay) >= 0) ? parseFloat(el.dataset.animationDelay) : 0.15;
                const offset = (parseFloat(el.dataset.animationOffset) >= 0) ? parseFloat(el.dataset.animationOffset) : 0;
                Array.from(el.children).forEach((elem, index) => {
                    elem.style.transitionDelay = `${ (index * delay) + offset }s`
                });
            }

            if(typeof el.dataset.appearGroup !== 'undefined') {
                const delay = (parseFloat(el.dataset.animationDelay) >= 0) ? parseFloat(el.dataset.animationDelay) : 0.15;
                const offset = (parseFloat(el.dataset.animationOffset) >= 0) ? parseFloat(el.dataset.animationOffset) : 0;
                Array.from(el.querySelectorAll('[data-appear-group-item]')).forEach((elem, index) => {
                    elem.style.transitionDelay = `${ (index * delay) + offset }s`
                });
            }

            if(typeof el.dataset.counterNum !== 'undefined') {
                el.counter = new CounterNums(el)
            }

            if(typeof el.dataset.svgAnimation !== 'undefined') {
                const animation = el.dataset.svgAnimation;
                this.svgAnimations[animation] = bodymovin.loadAnimation({
                    wrapper: el,
                    animType: 'svg',
                    loop: true,
                    autoplay: false,
                    animationData: window.lottie_svg_animations[animation],
                    name: animation
                });
                const playButton = document.createElement('a');
                playButton.href = "#"
                playButton.className = 'btn-bodymovin';
                playButton.onclick = (e) => {
                    e.preventDefault();
                    playButton.classList.toggle('paused');
                    bodymovin.togglePause(animation);
                };
                el.appendChild(playButton);
            }

            if(typeof el.dataset.appearTypein !== 'undefined') {
                this.typeIn(el);
            }

        })
    }

    handler(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let i = this.itemsBlock.indexOf(entry.target)
                let elem = this.cache[i]
                elem.isIntersected = true
                elem.el.classList.add('is-appeared');
                if(typeof elem.el.dataset.svgAnimation !== 'undefined') {
                    setTimeout(() => {
                        const animation = elem.el.dataset.svgAnimation;
                        this.svgAnimations[animation].play();
                    }, 500);
                }

                if(typeof elem.el.dataset.appearYtPlay !== 'undefined') {
                    setTimeout(() => {
                        elem.el.click();
                    }, 500);
                }

                if(typeof elem.el.dataset.counterNum !== 'undefined') {
                    elem.el.counter.run()
                }

                if(typeof elem.el.dataset.appearIllustration !== 'undefined') {
                    if(typeof elem.el.timeline !== 'undefined') {
                        setTimeout(() => {
                            elem.el.timeline.play();
                            gsap.to(elem.el, {duration: 0.3, opacity: 1});
                        }, 300)
                    } else {
                        elem.el.mustplay = true;
                    }
                }

                if(typeof elem.el.dataset.appearCorner !== 'undefined') {
                    this.clipPathAnimation(elem.el)
                }

                if(typeof elem.el.dataset.appearTypein !== 'undefined') {
                    if(typeof elem.el.timeline !== 'undefined') {
                        elem.el.timeline.play();
                    } else {
                        elem.el.mustplay = true;
                    }
                }

                if(typeof elem.el.dataset.appearStagger !== 'undefined') {
                    // clear the transition delay after animation
                    setTimeout(() => {
                        Array.from(elem.el.children).forEach((elem, index) => {
                            elem.style.transitionDelay = ''
                        });
                    }, 2000);
                }

                this.stillObserving() ? this.observer.unobserve(entry.target) : this.observer.disconnect()
            } else {
                return
            }
        })
    }

    stillObserving() {
        return this.cache.some(e => !e.isIntersected)
    }

    clipPathAnimation(el) {
        el.querySelectorAll('.corner-line').forEach((item) => {
            setTimeout(() => {
                gsap.to(item, {
                    clipPath: 'inset(0% 0% 0% 0%)',
                    duration: 3,
                    opacity: 0.15,
                    ease: 'none'
                });
            }, 300);
        });
    }


    destroy() {
        this.observer.disconnect()
        this.observer = null
        this.elems = null
        this.cache = null
    }
}

export default AnimatedAppearingScroll
